export const PromoCodeLink = angular
    .module('checkout.components.promoCodeLink', [])
    .component('promoCodeLink', {
        template: `
            <button
                class="checkout-button checkout-button--flat promo-code-link"
                type="button"
                ng-click="$ctrl.onLinkClicked()">
                Have a promo code?
            </button>
        `,
        controller: class PromoCodeLinkCtrl {
            constructor($rootScope, $timeout, $anchorScroll) {
                this.$rootScope = $rootScope;
                this.$timeout = $timeout;
                this.$anchorScroll = $anchorScroll;
            }

            onLinkClicked() {
                this.$rootScope.$emit('OrderSummaryCtrl:ForcePromoInputVisible');
                this.scrollToId('checkout-order-summary');
            }

            scrollToId(selector) {
                this.$timeout(() => {
                    this.$anchorScroll(selector);
                });
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/promoCodeLink/promoCodeLink.js